export default __webpack_public_path__ + "static/media/illus05.40262136.png";